module.exports = __webpack_public_path__ + "img/history_gallery_2.c9a081ef.png";